import { render } from "./PrismaDiagram2.vue?vue&type=template&id=8bfd145e"
import script from "./PrismaDiagram2.vue?vue&type=script&lang=js"
export * from "./PrismaDiagram2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__